"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.turnoverSelect = exports.todayString = exports.isSlide1Valid = exports.checkCondition = void 0;
const turnoverSelect = _translate => [{
  value: "common_turnover_2y_or_less_150k",
  label: _translate("common_turnover_2y_or_less_150k")
}, {
  value: "common_turnover_150k_to_300k",
  label: _translate("common_turnover_150k_to_300k")
}, {
  value: "common_turnover_300k_to_1M",
  label: _translate("common_turnover_300k_to_1M")
}, {
  value: "common_turnover_1M_to_3M",
  label: _translate("common_turnover_1M_to_3M")
}, {
  value: "common_turnover_3M_to_10M",
  label: _translate("common_turnover_3M_to_10M")
}, {
  value: "common_turnover_10M_to_50M",
  label: _translate("common_turnover_10M_to_50M")
}, {
  value: "common_turnover_50M_to_100M",
  label: _translate("common_turnover_50M_to_100M")
}, {
  value: "common_turnover_100M_to_500M",
  label: _translate("common_turnover_100M_to_500M")
}, {
  value: "common_turnover_500M_to_1MD",
  label: _translate("common_turnover_500M_to_1MD")
}, {
  value: "common_turnover_more_1MD",
  label: _translate("common_turnover_more_1MD")
}, {
  value: "common_turnover_association_prof",
  label: _translate("common_turnover_association_prof")
}, {
  value: "common_turnover_farmer",
  label: _translate("common_turnover_farmer")
}];

/**
 * Permet de vérifier si les condition sont ok.
 * 
 * @param {object} condition 
 * @returns 
 */
exports.turnoverSelect = turnoverSelect;
const checkCondition = (condition, formDynamic) => {
  let isValid = true;
  if (!condition || !condition.parameters) {
    return isValid;
  }
  ;
  isValid = false;
  const value = formDynamic[condition.parameters.question];
  const answers = condition.parameters.responses;
  if (typeof value !== 'object' && answers[value]) {
    isValid = true;
  } else if (typeof value === 'object') {
    Object.keys(value).forEach(key => {
      if (value[key] && answers[key]) {
        isValid = true;
      }
    });
  }
  return isValid;
};

/**
 * Permet d'obtenir la date du jour au format YYYY-MM-DD.
 *
 * @returns {string}
 */
exports.checkCondition = checkCondition;
const todayString = () => {
  const today = new Date();

  // Formatez la date au format YYYY-MM-DD
  const year = today.getFullYear();
  const month = String(today.getMonth() + 1).padStart(2, '0');
  const day = String(today.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
};
exports.todayString = todayString;
const isSlide1Valid = (formDynamic, _translate, notifications) => {
  const isValid = formDynamic['name'] && formDynamic['address'] && formDynamic['createdAt'] && formDynamic['turnover'] && formDynamic['capacity'];
  const regexNaf = /^\d{4}[A-Za-z]$/;
  if (formDynamic['code_naf_ape'] && !regexNaf.test(formDynamic['code_naf_ape'])) {
    notifications.error(_translate('collectorapp_server_error'), _translate('registerapp_club_error_codenaf_invalid'));
    return;
  }
  const regex = /^^[0-9 ]{14,18}$/;
  if (formDynamic['siret'] && !regex.test(formDynamic['siret'])) {
    notifications.error(_translate('collectorapp_server_error'), _translate('registerapp_club_error_siret_invalid'));
    return;
  }
  if (!isValid) {
    notifications.error(_translate('collectorapp_server_error'), _translate('registerapp_club_error_slide1'));
  }
  return isValid;
};
exports.isSlide1Valid = isSlide1Valid;